import { getApp, getApps, initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import type { User } from 'firebase/auth'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET
}

// Initialize once and reuse default app across modules.
export const app = getApps().length ? getApp() : initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Configure Google Auth Provider
export const googleProvider = new GoogleAuthProvider()
googleProvider.addScope('email')
googleProvider.addScope('profile')

// Firebase Auth functions
export const signInWithGooglePopup = () => signInWithPopup(auth, googleProvider)

// Helper function to get current user
export const getCurrentUser = (): User | null => {
  return auth.currentUser
}

// Helper function to get ID token
export const getIdToken = async (): Promise<string | null> => {
  const user = getCurrentUser()
  if (!user) return null
  return await user.getIdToken()
}

// Helper function to sign out
export const signOut = () => {
  return auth.signOut()
}

// Auth state change listener
export const onAuthStateChanged = (callback: (user: User | null) => void) => {
  return auth.onAuthStateChanged(callback)
}
